module.exports = __webpack_public_path__ + "static/media/yamogato_classic.22d3b4fd.webp";